import axios from 'axios';
import Button from 'components/CustomButton/CustomButton.jsx';
import React, { Component } from 'react';
import { Alert, Col, Grid, Media, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as UsersActions from '../Users/redux/UsersActions';

const alertPasswordError = (
    <Alert bsStyle="danger" style={{ marginTop: 10 }}>
        <span>
            <b> Error - </b> La contraseña no coincide en la validación
        </span>
    </Alert>
);

const emailExistError = (
    <Alert bsStyle="danger" style={{ marginTop: 10 }}>
        <span>
            <b> Error - </b> Ya existe un usuario registrado con este correo
        </span>
    </Alert>
);

// const errorCreateUser = (
//     <Alert bsStyle="danger" style={{ marginTop: 10 }}>
//         <span>
//             <b> Error - </b> Error al crear el usuario
//         </span>
//     </Alert>
// );

const resultSuccessfull = (
    <Alert bsStyle="success" style={{ marginTop: 10 }}>
        <span>
            <b> Confirmado - </b> Tu usuario se ha creado correctamente, te
            enviaremos un correo electrónico en cuento esté verificada tu
            cuenta.
        </span>
    </Alert>
);

class RegisterForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                company: '',
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                password: '',
                passwordConfirm: '',
                roles: ['client']
            },
            passwordVerification: false,
            showResultsPasswordVerification: '',
            showResultsVerification: '',
            showResultsSuccessfull: ''
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ formData: nextProps.Users.formData });
    }

    onChange = (name, value) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
    };

    onChangePasswordConfirmation = (name, value) => {
        if (value === this.state.formData.password) {
            this.setState({
                passwordVerification: true,
                showResultsPasswordVerification: ''
            });
        } else {
            this.setState({
                passwordVerification: false,
                showResultsPasswordVerification: alertPasswordError
            });
        }

        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });

        console.log('formData', this.state.formData);
    };

    onSubmitClick = async e => {
        // let _this = this;
        if (
            !this.state.passwordVerification &&
            this.state.formData.passwordConfirm === ''
        ) {
            console.log('No coinciden');
            this.setState({
                showResultsPasswordVerification: alertPasswordError
            });
            return false;
        } else if (
            this.state.formData.passwordConfirm === this.state.formData.password
        ) {
            try {
                await axios.post(
                    process.env.REACT_APP_URL_API + '/api/users/create-client',
                    this.state.formData
                );

                this.setState({
                    showResultsSuccessfull: resultSuccessfull,
                    showResultsVerification: ''
                });
            } catch (error) {
                if (error.status === 422) {
                    this.setState({
                        showResultsSuccessfull: '',
                        showResultsVerification: emailExistError
                    });
                }
            }
        }
    };

    render() {
        let { formData } = this.state;

        return (
            <Grid>
                <Row>
                    <Col md={8} mdOffset={2}>
                        <div className="header-text">
                            <h2>Bienvenido</h2>
                            <h4>
                                Únete y forma parte de la Asociación de Agentes
                                Aduanales de Lázaro Cárdenas
                            </h4>
                            <hr />
                        </div>
                    </Col>
                    <Col md={4} mdOffset={2}>
                        <Media>
                            <Media.Left>
                                <div className="icon">
                                    <i className="pe-7s-user" />
                                </div>
                            </Media.Left>
                            <Media.Body>
                                <Media.Heading>Registrarte</Media.Heading>
                                Al registrarte empezaras en un proceso de
                                verificación y validación de datos requeridos
                                para formar parte de la comunidad AAALAC
                            </Media.Body>
                        </Media>
                        <Media>
                            <Media.Left>
                                <div className="icon">
                                    <i className="pe-7s-graph1" />
                                </div>
                            </Media.Left>
                            <Media.Body>
                                <Media.Heading>Servicios</Media.Heading>
                                Somos una empresa de consultoría de apoyo y
                                servicios; encargada de representar a sus
                                asociados, sin fines de lucro, antes las
                                autoridades que intervienen en el despacho
                                aduanero.
                            </Media.Body>
                        </Media>
                        <Media>
                            <Media.Left>
                                <div className="icon">
                                    <i className="pe-7s-headphones" />
                                </div>
                            </Media.Left>
                            <Media.Body>
                                <Media.Heading>Política</Media.Heading>
                                La Asociación de Agentes Aduanales de Lázaro
                                Cárdenas, trabaja en ofrecer servicios que
                                generan valor para los agentes aduanales
                                asociados, dentro de la caneda logística de la
                                importación y exportación, utilizando la
                                tecnología necesaria, además de estar
                                comprometidos con la mejora continua.
                            </Media.Body>
                        </Media>
                    </Col>
                    <Col md={4}>
                        <form onSubmit={this.onSubmitClick}>
                            <Row>
                                <div className="form-group">
                                    <label
                                        htmlFor="company"
                                        style={{
                                            color: '#FFF',
                                            fontSize: '16px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Empresa
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="company"
                                        value={formData.company}
                                        onChange={event =>
                                            this.onChange(
                                                'company',
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="firstName"
                                        style={{
                                            color: '#FFF',
                                            fontSize: '16px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Nombre
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="firstName"
                                        value={formData.firstName}
                                        onChange={event =>
                                            this.onChange(
                                                'firstName',
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="lastName"
                                        style={{
                                            color: '#FFF',
                                            fontSize: '16px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Apellidos
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="lastName"
                                        value={formData.lastName}
                                        onChange={event =>
                                            this.onChange(
                                                'lastName',
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="phone"
                                        style={{
                                            color: '#FFF',
                                            fontSize: '16px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Teléfono
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="phone"
                                        value={formData.phone}
                                        onChange={event =>
                                            this.onChange(
                                                'phone',
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="email"
                                        style={{
                                            color: '#FFF',
                                            fontSize: '16px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        required
                                        className="form-control"
                                        id="email"
                                        value={formData.email}
                                        onChange={event =>
                                            this.onChange(
                                                'email',
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="password"
                                        style={{
                                            color: '#FFF',
                                            fontSize: '16px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Contraseña
                                    </label>
                                    <input
                                        type="password"
                                        required
                                        className="form-control"
                                        id="password"
                                        value={formData.password}
                                        onChange={event =>
                                            this.onChange(
                                                'password',
                                                event.target.value
                                            )
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label
                                        htmlFor="passwordConfirm"
                                        style={{
                                            color: '#FFF',
                                            fontSize: '16px',
                                            fontWeight: '500'
                                        }}
                                    >
                                        Confirmar Contraseña
                                    </label>
                                    <input
                                        type="password"
                                        required
                                        className="form-control"
                                        id="passwordConfirm"
                                        value={formData.passwordConfirm}
                                        onChange={event =>
                                            this.onChangePasswordConfirmation(
                                                'passwordConfirm',
                                                event.target.value
                                            )
                                        }
                                    />
                                    {/*!this.state.passwordVerification && this.state.formData.passwordConfirm != "" ? <div>hola</div> : null*/}
                                    {this.state.showResultsPasswordVerification}
                                </div>
                                <label
                                    htmlFor="confirm"
                                    id="showConfirm"
                                    style={{
                                        color: '#FFF',
                                        fontSize: '16px',
                                        fontWeight: '500'
                                    }}
                                    hidden
                                >
                                    Las contraseñas no coinciden !
                                </label>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    {this.state.showResultsVerification}
                                    {this.state.showResultsSuccessfull}
                                </Col>
                            </Row>
                            <div className="pull-right">
                                <Row style={{ marginTop: 25 }}>
                                    <Col md={12}>
                                        <Button
                                            bsStyle="success"
                                            type="submit"
                                            className="btn-fill"
                                        >
                                            Enviar
                                        </Button>{' '}
                                    </Col>
                                </Row>
                            </div>
                        </form>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    return {
        Users: state.Users
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(UsersActions, dispatch);
};

const UsersConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterForm);

export default UsersConnect;



// WEBPACK FOOTER //
// ./src/views/Pages/RegisterPage.jsx